<template>
  <div v-if="!isMobile()">
    <div
      class="section section-governancefeatures"
      id="governancefeatures-section"
      data-background-color="white"
    >
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <h1 data-aos="fade-up" class="title deco1">{{ $t(`Features`) }}</h1>
            <div class="governance-effect">
              <img v-lazy="'/img/img_sub_governance.png'" width="100%" />
              <img
                data-aos="fade-in"
                data-aos-offset="-100"
                data-aos-delay="1000"
                style="position: absolute; left: 340px; top: 220px"
                v-lazy="'/img/img_sub_governance_01.png'"
              />
              <img
                data-aos="fade-right"
                data-aos-offset="-100"
                data-aos-delay="100"
                style="position: absolute; left: 105px; top: 210px"
                v-lazy="'/img/img_sub_governance_02.png'"
              />
              <img
                data-aos="fade-down"
                data-aos-offset="-100"
                data-aos-delay="300"
                style="position: absolute; right: 165px; top: 112px"
                v-lazy="'/img/img_sub_governance_03.png'"
              />
              <img
                data-aos="fade-left"
                data-aos-offset="-900"
                data-aos-delay="500"
                style="position: absolute; right: 35px; bottom: 465px"
                v-lazy="'/img/img_sub_governance_04.png'"
              />
            </div>
            <div class="governance-effect-m">
              <img v-lazy="'/img/img_sub_governance_m.png'" width="100%" />
            </div>
            <div class="row" style="margin-top: 10px">
              <div
                data-aos="fade-right"
                data-aos-offset="-400"
                class="col-lg-4"
              >
                <div
                  class="col-lg-12 box-blockchain"
                  style="padding: 5px 5px 0px; min-height: 440px"
                >
                  <img v-lazy="'/img/img_game_09.png'" width="100%" />
                  <h5 class="governance-title" style="margin-top: 20px">
                    {{ $t(`governance features title 1`) }}
                  </h5>
                  <h5
                    class="governance-desc"
                    style="margin: 20px 30px 0px; min-height: 150px"
                  >
                    {{ $t(`governance features desc 1`) }}
                  </h5>
                </div>
              </div>
              <div data-aos="fade-up" data-aos-offset="-400" class="col-lg-4">
                <div
                  class="col-lg-12 box-blockchain"
                  style="padding: 5px 5px 0px; min-height: 440px"
                >
                  <img v-lazy="'/img/img_game_10.png'" width="100%" />
                  <h5 class="governance-title" style="margin-top: 20px">
                    {{ $t(`governance features title 2`) }}
                  </h5>
                  <h5
                    class="governance-desc"
                    style="margin: 20px 30px 0px; min-height: 150px"
                  >
                    {{ $t(`governance features desc 2`) }}
                  </h5>
                </div>
              </div>
              <div data-aos="fade-left" data-aos-offset="-400" class="col-lg-4">
                <div
                  class="col-lg-12 box-blockchain"
                  style="padding: 5px 5px 0px; min-height: 440px"
                >
                  <img v-lazy="'/img/img_game_14.png'" width="100%" />
                  <h5 class="governance-title" style="margin-top: 20px">
                    {{ $t(`governance features title 3`) }}
                  </h5>
                  <h5
                    class="governance-desc"
                    style="margin: 20px 30px 0px; min-height: 150px"
                  >
                    {{ $t(`governance features desc 3`) }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div
      class="section-m section-governancefeatures"
      id="governancefeatures-section"
      data-background-color="white"
    >
      <div class="container" style="width: 85%;">
        <div class="row justify-content-md-center">
          <div class="text-center col-md-12 col-lg-12">
            <h1 class="title-m deco1">{{ $t(`Features`) }}</h1>
            <div class="governance-effect">
              <img v-lazy="'/img/img_sub_governance.png'" width="100%" />
              <img
                style="position: absolute; left: 340px; top: 220px"
                v-lazy="'/img/img_sub_governance_01.png'"
              />
              <img
                style="position: absolute; left: 105px; top: 210px"
                v-lazy="'/img/img_sub_governance_02.png'"
              />
              <img
                style="position: absolute; right: 165px; top: 112px"
                v-lazy="'/img/img_sub_governance_03.png'"
              />
              <img
                style="position: absolute; right: 35px; bottom: 465px"
                v-lazy="'/img/img_sub_governance_04.png'"
              />
            </div>
            <div class="governance-effect-m">
              <img v-lazy="'/img/img_sub_governance_m.png'" width="100%" />
            </div>
            <div class="row" style="margin-top: 10px">
              <div
                class="col-lg-4"
              >
                <div
                  class="col-lg-12 box-blockchain-m"
                  style="padding: 5px 5px 0px; min-height: 340px"
                >
                  <img v-lazy="'/img/img_game_09.png'" width="100%" />
                  <h5 class="governance-title-m" style="margin-top: 20px">
                    {{ $t(`governance features title 1`) }}
                  </h5>
                  <h5
                    class="governance-desc-m"
                    style="margin: 20px 30px 0px; min-height: 80px"
                  >
                    {{ $t(`governance features desc 1`) }}
                  </h5>
                </div>
              </div>
              <div data-aos="fade-up" data-aos-offset="-400" class="col-lg-4">
                <div
                  class="col-lg-12 box-blockchain-m"
                  style="padding: 5px 5px 0px; min-height: 340px"
                >
                  <img v-lazy="'/img/img_game_10.png'" width="100%" />
                  <h5 class="governance-title-m" style="margin-top: 20px">
                    {{ $t(`governance features title 2`) }}
                  </h5>
                  <h5
                    class="governance-desc-m"
                    style="margin: 20px 30px 0px; min-height: 80px"
                  >
                    {{ $t(`governance features desc 2`) }}
                  </h5>
                </div>
              </div>
              <div class="col-lg-4">
                <div
                  class="col-lg-12 box-blockchain-m"
                  style="padding: 5px 5px 0px; min-height: 340px"
                >
                  <img v-lazy="'/img/img_game_14.png'" width="100%" />
                  <h5 class="governance-title-m" style="margin-top: 20px">
                    {{ $t(`governance features title 3`) }}
                  </h5>
                  <h5
                    class="governance-desc-m"
                    style="margin: 20px 30px 0px; min-height: 80px"
                  >
                    {{ $t(`governance features desc 3`) }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style></style>
